import { update, UPDATE } from 'model/fspConfig';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useFSPConfig, useParamId } from 'hooks';
import { transform } from './consts';
import { useFormikInnerRef } from '../index';

const useFormikProps = ({
  fspConfigInitValues,
  fspConfigKey,
  keys,
  offOn,
  onBeforeSubmit,
}) => {
  const dispatch = useDispatch();
  const fspId = useParamId();
  const fspConfig = useFSPConfig(fspId, false);
  const ref = useFormikInnerRef(UPDATE);

  const initialValues = transform(
    fspConfig,
    fspConfigKey,
    fspConfigInitValues,
    keys
  );

  const onSubmit = useCallback(
    (values) => {
      // only submit data needed from fspConfig
      const data = {};

      if (fspConfigKey) {
        data[fspConfigKey] = { ...values[fspConfigKey] };
      }

      if (Array.isArray(keys) && keys.length) {
        keys.forEach((key) => {
          data[key] = values[key];
        });
      }

      if (offOn) {
        data[offOn] = values[offOn];
      }

      dispatch(update({ fspId, id: fspConfig.id, ...onBeforeSubmit(data) }));
    },
    [dispatch, fspConfig.id, fspConfigKey, fspId, keys, offOn, onBeforeSubmit]
  );

  return [initialValues, onSubmit, ref];
};

export default useFormikProps;
